import { get, writable } from "svelte/store";
import API from "../../API/API";
import LoadState from "../../Enums/LoadState";

const ShippingLanesFiltersStore = {
	meta: {
		loadState: writable(LoadState.INIT)
	},
	filters: {},

	fetchFilters: () => {
		if (get(ShippingLanesFiltersStore.meta.loadState) !== LoadState.INIT) {
			return;
		}

		ShippingLanesFiltersStore.meta.loadState.set(LoadState.LOADING);

		API.get("shipping-lanes/config")
			.then((result) => {
				ShippingLanesFiltersStore.filters = {
					flag: result.data.flag,
					shipType: result.data.shiptype,
					custom: result.data.custom
				};
				ShippingLanesFiltersStore.meta.loadState.set(LoadState.LOADED);
			})
			.catch((err) => {
				console.error("error", err);
				ShippingLanesFiltersStore.meta.loadState.set(LoadState.ERROR);
			});
	}
};

export default ShippingLanesFiltersStore;
